const en = {
  about: 'About',
  companyManagement: 'Company Management',
  articles: 'Articles',
  contributorsTxt: 'contributors',
  tools: 'Tools',
  library: 'Library',
  longevity: 'Longevity Protocol',
  aiAtlas: 'AI Atlas',
};

export default en;
